import React, { useState, useEffect } from 'react';
import { map, groupBy, flatten } from 'lodash';
import InfoToolTip from '../../../../admin/common/infoToolTip';

const ResetConceptsOrder = ({ data, concepts, setConcepts, setSort }) => {
  const updateConceptIdsList = () => map(concepts || [], (el) => el.id);
  const [ initialOrder ] = useState(data?.db_concepts_order || []);
  const [ conceptIdsList, setConceptIdsList ] = useState(updateConceptIdsList);
  useEffect(() => {
    setConceptIdsList(updateConceptIdsList());
  }, [ concepts ]);

  const conceptsOrderNotEqualInit = (
    !!initialOrder.length &&
    !!conceptIdsList.length &&
    initialOrder.join(',') !== conceptIdsList.join(',')
  );

  const handleResetOrder = () => {
    const conceptsByHash = groupBy(concepts, (el) => el.id);
    const newConceptsList = flatten(
      map(initialOrder, (id) => (conceptsByHash[id] || []))
    );
    setConcepts(newConceptsList);
    setSort('');
  };

  return (
    <>
      {
        conceptsOrderNotEqualInit &&
        <div className="reset-order-link">
          <a className="link -decorated" onClick={ handleResetOrder }>Reset Concepts Order</a>
          <InfoToolTip remote position={ 'bottom-right' } className="-force-margin">
            Resets the concepts order to the order of initial adding.
          </InfoToolTip>
        </div>
      }
    </>
  );
};

export default ResetConceptsOrder;
